
// function cpProductSlider(){
// const sliders = document.querySelectorAll("[data-slider]");

// sliders.forEach((slider) => {
//   const sliderInner = slider.querySelector(".cp-product-slider-inner");

//   if (sliderInner && sliderInner.children.length > 1) {
//     const config = JSON.parse(sliderInner.getAttribute("data-config"));
//     const flickityInstance = new Flickity(sliderInner, config);
//     const imgs = sliderInner.querySelectorAll("img");

//     imgs.forEach((img) => {
//       img.addEventListener("load", () => {
//         flickityInstance.resize();
//       });
//     });

//     if (typeof modelView !== "undefined" && modelView) {
//       flickityInstance.select(1);
//     } else {
//       flickityInstance.select(0);
//     }
//     const dots = sliderInner.querySelector(".flickity-page-dots");
//     let hideTimeout;

//     function showDotsTemporarily() {
//       if (!dots) return;
//       dots.style.opacity = "1"; 
//       clearTimeout(hideTimeout);
//       hideTimeout = setTimeout(() => {
//         dots.style.opacity = "0"; 
//       }, 1000);
//     }

//     flickityInstance.on("change", () => {
//       showDotsTemporarily();
//     });
//   }
// });

// }

// document.addEventListener("DOMContentLoaded", cpProductSlider);


function cpProductSlider() {
  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach((slider) => {
    const sliderInner = slider.querySelector(".cp-product-slider-inner");
    if (!sliderInner) return;

    const imgs = Array.from(sliderInner.querySelectorAll("img"));
    if (imgs.length <= 1) return;

    const config = JSON.parse(sliderInner.getAttribute("data-config"));
    
    // Wait for all images to load before initializing
    let loadedCount = 0;
    imgs.forEach((img) => {
      if (img.complete) loadedCount++;
      else img.addEventListener("load", () => {
        loadedCount++;
        if (loadedCount === imgs.length) initFlickity();
      });
    });

    if (loadedCount === imgs.length) initFlickity(); // all already loaded

    function initFlickity() {
      const flickityInstance = new Flickity(sliderInner, config);
      imgs.forEach((img) => {
        img.addEventListener("load", () => flickityInstance.resize());
      });

      if (typeof modelView !== "undefined" && modelView) {
        flickityInstance.select(1);
      } else {
        flickityInstance.select(0);
      }

      const dots = sliderInner.querySelector(".flickity-page-dots");
      let hideTimeout;

      function showDotsTemporarily() {
        if (!dots) return;
        dots.style.opacity = "1";
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(() => (dots.style.opacity = "0"), 1000);
      }

      flickityInstance.on("change", showDotsTemporarily);

      /*
        VEYNOU: Ruht die Maus kurz auf der Kachel, zeigen wir das zweite Foto -
        meist das Tragebild. Verlaesst sie die Kachel, geht es zurueck auf das
        Produktfoto. Die kurze Verzoegerung verhindert, dass beim blossen
        Ueberfahren des Rasters alle Kacheln durchblitzen.
      */
      const karte = slider.closest(".card, .card-wrapper, .product-item") || slider;
      const ohneAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      // Nur echte Zeigergeraete. Auf dem Handy wischt man ohnehin selbst, und
      // ein Antippen wuerde sonst kurz das Bild wechseln.
      const echterZeiger = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      let hoverTimeout;

      if (echterZeiger) karte.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          if (flickityInstance.slides.length > 1) flickityInstance.select(1, false, ohneAnimation);
        }, 200);
      });

      if (echterZeiger) karte.addEventListener("mouseleave", () => {
        clearTimeout(hoverTimeout);
        flickityInstance.select(0, false, ohneAnimation);
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", cpProductSlider);
